<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
        <div class="col-12"></div>
        <div class="col-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <!-- ngx-datatable-filter -->
                        <fieldset class="form-group">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                                    <!-- <div class="btn-group enrollment-list-btn-info" role="group">
                                        <button class="btn enrollment-list-buttons cursor-pointer" type="button" *ngFor="let status of type_List"
                                            [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                                            (click)="activeEmployeeTab(status?.name)">{{status.displayname}}</button>
                                    </div> -->
                                </div>
								<div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
									<div class="row-flex">
									  <div class="col-flex-2 mb-1 position-relative">
										<input id="ngx-filter-ref"
										  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
										  type="text"  placeholder="Search" #name [(ngModel)]="searchVal"
										  (keydown.enter)="filter(searchVal)"
										   />
										<button class="btn search-btn glow position-absolute" (click)="filter(searchVal)">
										  <i class="ft-search text-white cursor-pointer"></i>
										</button>
									  </div>
									  <div class="col-flex-2 mb-1" (click)="resetFilter()">
										<button class="btn btn-primary btn-block users-list-clear glow mb-0">Reset
										  <i class="ft-filter text-white cursor-pointer"></i>
										</button>
									  </div>
									  <div class="col-flex-2 mb-1"
										*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
										<button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
										 placement="top" ngbTooltip="Add New" (click)="add()">
										  +
										</button>
									  </div>
									</div>
								  </div>
								  <div class="col">
									<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Clients Guideline</button>
								  </div>
                            </div>
                        </fieldset>
                        <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows"
                            [scrollbarH]="true" [columns]="columns" [externalPaging]="true" [count]="page.totalPages"
                            [offset]="page.pageNumber" (page)="pageChangeData($event)">
                            <ngx-datatable-column name="Name" prop="name" [width]="50">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <div class="d-flex align-items-center">
										<div class="avatar mr-1 ml-0 bg-primary">
											<div class="avatar-content">
											  {{ row?.user_id[0]?.name | shortName }}
											</div>
										</div>
                                        <div class="cell-line-height cursor-pointer" (click)="confirmReadPassword(detailsModal,row)">
                                            <p class="font-medium-1 line-height-1 mb-0">
                                                {{ row?.user_id[0]?.name }}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                            <!-- <ngx-datatable-column name="Email" prop="email" [width]="60">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<p>{{row?.user_id[0]?.email}}</p>
								 </ng-template>
							</ngx-datatable-column> -->
                            <ngx-datatable-column name="Business" prop="businessId" [width]="50">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<p>{{row?.businessId[0]?.name}}</p>
								 </ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Client Type" prop="clienttype" [width]="30">
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                   <p>{{row?.clienttype[0]?.displayname}}</p>
                                </ng-template>
                            </ngx-datatable-column>
							<ngx-datatable-column name="Relationship Manager" prop="client_representive" [width]="30">
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                   <p>{{row?.client_representive[0]?.name}}</p>
                                </ng-template>
                            </ngx-datatable-column>
							<ngx-datatable-column name="Source" prop="source" [width]="30">
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                   <p>{{row?.source}}</p>
                                </ng-template>
                            </ngx-datatable-column>
							<ngx-datatable-column name="Actions"
							*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
							<ng-template let-row="row" ngx-datatable-cell-template>
							  <i class="ft-edit text-primary cursor-pointer mr-2" (click)="confirmPassword(row?.user_id[0]?._id)"></i>
							  <!-- <i class="ft-trash-2 cursor-pointer danger"
								(click)="ConfirmColor(row._id)"></i> -->
							</ng-template>
						  </ngx-datatable-column>
                        </ngx-datatable>
                        <!-- ngx-datatable-filter -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
</div>

<!-- --------- -->

<!----- -->
<div>
    <ng-template #detailsModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title">View</h4>
            <button type="button" class="close" (click)="modal.dismiss()">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
			<div class="form-group top-section">
				<h3>About</h3>
				<div class="d-flex my-3">
					<div>
						<img src="assets/img/no_logo_found.jpeg" width="100" alt="user-img">
					</div>
					<div class="mx-3 my-1">
						<h4>{{row_data?.user_id[0]?.name}}</h4>
						<p class="badge bg-light-secondary">{{row_data?.businessId[0]?.name}}</p>
						<p>{{row_data?.client_address}}</p>
						<p>{{row_data?.user_id[0]?.phone}}</p>
						<p>{{row_data?.user_id[0]?.email}}</p>
					</div>
				</div>
				
				
				<!-- <tr>
					<td class="title">Business / Contract</td>
					<td class="badge bg-light-secondary">{{row_data?.businessId[0]?.name}}</td>
				</tr>
				<tr>
					<td class="title">Client Representive</td>
					<td>{{row_data?.client_representive}}</td>
				</tr>
				<tr>
					<td class="title">History</td>
					<td>{{row_data?.history}}</td>
				</tr>
				<tr>
					<td class="title">Client Type</td>
					<td class="badge bg-light-info">{{row_data?.clienttype[0]?.displayname}}</td>
				</tr>
				<tr>
					<td class="title">Source</td>
					<td>{{row_data?.source}}</td>
				</tr>
				<tr>
					<td class="title">Source Link</td>
					<td>{{row_data?.source_link}}</td>
				</tr>
				<tr>
					<td class="title">Documents</td>
					<td>{{row_data?.documents}}</td>
				</tr>
				<tr>
					<td class="title">Bank Info</td>
					<td>{{row_data?.bankinfo}}</td>
				</tr> -->
				
			</div>
			<div class="form-group bottom-section">
				<h3>Other Information</h3>
				<tr>
					<td class="title">Client Representive</td>
					<td>{{row_data?.client_representive[0]?.name}}</td>
				</tr>
				<tr>
					<td class="title">History</td>
					<td>{{row_data?.history}}</td>
				</tr>
				<tr>
					<td class="title">Client Type</td>
					<td class="badge bg-light-info">{{row_data?.clienttype[0]?.displayname}}</td>
				</tr>
				<tr>
					<td class="title">Source</td>
					<td>{{row_data?.source}}</td>
				</tr>
				<tr>
					<td class="title">Source Link</td>
					<td>{{row_data?.source_link}}</td>
				</tr>
				<tr>
					<td class="title">Documents</td>
					<td>{{row_data?.documents}}</td>
				</tr>
				<tr>
					<td class="title">Payment Info</td>
					<td>{{row_data?.bankinfo}}</td>
				</tr>
				<div class="d-flex my-1">
					<span *ngFor="let lead of row_data?.lead"  >
						<span> Lead <a style="color: #975aff;" (click)="gotoLink(lead?._id, 'lead')">{{lead}}</a></span>
					</span>
				</div>
				<div class="d-flex my-1">
					<span *ngFor="let contract of row_data?.contract" (click)="gotoLink(contract?._id, 'contract')" >
						<!-- {{contract?.name}} -->
						<span> Contract <a  style="color: #975aff;" (click)="gotoLink(contract?._id, 'contract')">{{contract?.name}}</a></span>
					</span>
				</div>
				<div class="d-flex my-1">
					<span *ngFor="let product of row_data?.product" (click)="gotoLink(product?._id, 'product')" >
						<!-- {{product?.name}} -->
						<span> Product <a  style="color: #975aff;" (click)="gotoLink(product?._id, 'product')">{{product?.name}}</a></span>

					</span>
				</div>
				<div class="d-flex my-1">
					<span *ngFor="let project of row_data?.project" (click)="gotoLink(project?._id, 'project')" >
						<!-- {{project?.name}} -->
						<span> Project <a  style="color: #975aff;" (click)="gotoLink(project?._id, 'project')">{{project?.name}}</a></span>
					</span>
				</div>
			</div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        </div>
    </ng-template>
</div>

